import styled from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system';

export const TimerBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;

	@media (${BREAKPOINTS.NOT_DESKTOP}) {
		align-items: center;
	}
`;

export const TimerLabel = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.subtitle};
	text-transform: uppercase;

	@media (${BREAKPOINTS.MOBILE}) {
		text-align: center;
	}
`;

export const TimerValues = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;

	@media (${BREAKPOINTS.MOBILE}) {
		justify-content: center;
	}
`;

export const TimerUnit = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
`;

export const TimerValue = styled.div`
	font-size: 20px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
`;

export const TimerUnitLabel = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const TimerSeparator = styled.div`
	font-size: 20px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.body};
	margin-top: -12px;
`;

export const TimerFinished = styled.div`
	font-size: 16px;
	color: ${({ theme }) => theme.colors.text.body};
	font-weight: 500;
`;
